import { createContext } from 'react';
import { MultiChatTaskContextType } from '@scale/shared/types/chat';

export const MultiChatTaskContext = createContext<MultiChatTaskContextType>({});
